var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "both-pd-box" },
    [
      _c("h3", [_vm._v("商品标签配置")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-card" },
        [
          _c("h3", [_vm._v('标签1: "返" 配置项')]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form1",
              staticClass: "demo-form",
              attrs: {
                model: _vm.form1,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "左侧图标(文字图)", prop: "imgUrl" } },
                [
                  _c("upload", {
                    attrs: { name: "fanImgUrl", "img-url": _vm.form1.imgUrl },
                    on: {
                      pictureAddress: function ($event) {
                        return _vm.onPictureAddress($event, "form1")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                    _vm._v("建议图片高度32px，宽度自定义，PNG格式"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额背景色", prop: "bgColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form1.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "bgColor", $$v)
                          },
                          expression: "form1.bgColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form1.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "bgColor", $$v)
                          },
                          expression: "form1.bgColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额文字色", prop: "textColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form1.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "textColor", $$v)
                          },
                          expression: "form1.textColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form1.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "textColor", $$v)
                          },
                          expression: "form1.textColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form1")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form1")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-card" },
        [
          _c("h3", [_vm._v('标签2: "升级返" 配置项')]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form2",
              staticClass: "demo-form",
              attrs: {
                model: _vm.form2,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "左侧图标(文字图)", prop: "imgUrl" } },
                [
                  _c("upload", {
                    attrs: {
                      name: "upgradeImgUrl",
                      "img-url": _vm.form2.imgUrl,
                    },
                    on: {
                      pictureAddress: function ($event) {
                        return _vm.onPictureAddress($event, "form2")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                    _vm._v("建议图片高度32px，宽度自定义，PNG格式"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额背景色", prop: "bgColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form2.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "bgColor", $$v)
                          },
                          expression: "form2.bgColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form2.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "bgColor", $$v)
                          },
                          expression: "form2.bgColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额文字色", prop: "textColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form2.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "textColor", $$v)
                          },
                          expression: "form2.textColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form2.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "textColor", $$v)
                          },
                          expression: "form2.textColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form2")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form2")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-card" },
        [
          _c("h3", [_vm._v('标签3: "券" 配置项')]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form3",
              staticClass: "demo-form",
              attrs: {
                model: _vm.form3,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "左侧图标(文字图)", prop: "imgUrl" } },
                [
                  _c("upload", {
                    attrs: {
                      name: "couponImgUrl",
                      "img-url": _vm.form3.imgUrl,
                    },
                    on: {
                      pictureAddress: function ($event) {
                        return _vm.onPictureAddress($event, "form3")
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                    _vm._v("建议图片高度32px，宽度自定义，PNG格式"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额背景色", prop: "bgColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form3.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form3, "bgColor", $$v)
                          },
                          expression: "form3.bgColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form3.bgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form3, "bgColor", $$v)
                          },
                          expression: "form3.bgColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧金额文字色", prop: "textColor" } },
                [
                  _c(
                    "div",
                    { staticClass: "color-row" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form3.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form3, "textColor", $$v)
                          },
                          expression: "form3.textColor",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-color-picker", {
                        model: {
                          value: _vm.form3.textColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form3, "textColor", $$v)
                          },
                          expression: "form3.textColor",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("form3")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleReset("form3")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "20px",
          color: "#F59A23",
          "background-color": "#FDF6EC",
          padding: "20px",
          "border-radius": "10px",
        },
      },
      [
        _c("div", [
          _vm._v(
            "\n      商品列表上展示的“返”“券”“升级返”三种标签类型的样式\n    "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }